import React            from 'react';
import ThemeModeContext from '@widesk-ui/contexts/ThemeModeContext';

export default function useThemeMode() {
	return React.useContext(ThemeModeContext);
}
